interface AppContainerProps {
  children: React.ReactNode;
}
const AppContainer = ({ children }: AppContainerProps) => {
  return <>{children}</>;
};

export default AppContainer;
